var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1.5c7 0 11.5 5.75 11.5 11.5 0 7.087-6.4 11.67-9.65 13.54-.51.293-.764.44-1.228.538a3.809 3.809 0 0 1-1.244 0c-.464-.098-.718-.245-1.228-.538C8.9 24.67 2.5 20.087 2.5 13 2.5 7.25 7 1.5 14 1.5ZM14 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation28);
export default __webpack_public_path__ + "static/media/location_28.51820019.svg";
export { ForwardRef as ReactComponent };